// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartUtils.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!(function() {
  const { get, isNil, isEmpty } = require('lodash/fp');
  var ReportDesignerConstants = require('logic/data/Izenda.ReportDesignerConstants');
  var FORMAT_VALUE_INPUT = require('logic/data/Izenda.AppGlobalConstants').DATE_TIME_FORMAT;
  var ReportPartFieldConstants = require('logic/data/Izenda.ReportPartFieldConstants');
  var DATE_GROUP_BY = require('logic/data/Izenda.TimeFormatConstants').GROUP_BY;

  function previewDataTypeByFunction(functionInfo, dataFieldType) {
    return functionInfo.formatDataType || dataFieldType;
  }

  function getDateTimeFormatData(originalDataType, functionInfo, format) {
    var dataType = get('formatDataType', functionInfo) || originalDataType;

    if (dataType === ReportDesignerConstants.DATA_TYPES.DATE_TIME) {
      var groupBy = get('groupBy', format);
      var settingByGroupBy = get(groupBy, DATE_GROUP_BY);

      return {
        groupBy: groupBy,
        settingByGroupBy: settingByGroupBy,
        dataFormat:
          (get('name', functionInfo) === ReportPartFieldConstants.FUNCTION.GROUP.NAME &&
            get('GROUP_BY_EXPECTED_FORMAT', settingByGroupBy)) ||
          FORMAT_VALUE_INPUT,
        compareFormat: get('COMPARE_FORMAT', settingByGroupBy) || FORMAT_VALUE_INPUT
      };
    }
    return null;
  }

  function checkUsingCustomFormat(element) {
    const formatName = get('reportPartElm.properties.dataFormattings.format.format', element);
    const formatId = get('reportPartElm.properties.dataFormattings.format.formatId', element);
    return !isNil(formatId) && (isEmpty(formatName) || isNil(formatName));
  }

  function checkUsingCustomStringFormat(element) {
    var jsFormatString = get('reportPartElm.properties.dataFormattings.format.jsFormatString', element);
    return !isNil(jsFormatString) || !isEmpty(jsFormatString);
  }

  module.exports = {
    previewDataTypeByFunction: previewDataTypeByFunction,
    getDateTimeFormatData: getDateTimeFormatData,
    checkUsingCustomFormat: checkUsingCustomFormat,
    checkUsingCustomStringFormat: checkUsingCustomStringFormat
  };
})();



// WEBPACK FOOTER //
// ./ui/share/utils/Izenda.ReportPartElementUtils.js